import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { LoaderModule } from '../loader/loader.module';

import { AiTopicSettingsRoutingModule } from './ai-topic-settings-routing.module';
import { AiTopicComponent } from './ai-topic/ai-topic.component';
import { TopicModalComponent } from './topic-modal/topic-modal.component';
import { SubTopicModalComponent } from './sub-topic-modal/sub-topic-modal.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { LocalTopicManagerComponent } from './local-topic-manager/local-topic-manager.component';

@NgModule({
  declarations: [
    AiTopicComponent,
    TopicModalComponent,
    SubTopicModalComponent,
    ConfirmDialogComponent,
    LocalTopicManagerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ToastModule,
    LoaderModule,
    AiTopicSettingsRoutingModule
  ],
  providers: [
    MessageService
  ],
  exports: [
    AiTopicComponent,
    LocalTopicManagerComponent
  ]
})
export class AiTopicSettingsModule { }
